import { getLogger } from "@/utils/log";

export const logger = getLogger(["backend"]);